import React from 'react';
import { useRemote } from './api';
import { useAuth } from './context';
import { Empty, LoadState, PageTitle } from './ui';
import { OrderItem } from './orders/OrderItem';

const OrderList = ({ remote, user }) => {
  if (remote.loading || remote.error) return <LoadState remote={remote} />;
  if (!remote.data?.length) return <Empty title="No purchase orders yet"
    text="An accepted supplier quotation becomes a purchase order here." to="/workspace/rfqs" label="View quotation requests" />;
  return <div className="request-list">{remote.data.map(order => <OrderItem key={order.id}
    order={order} user={user} reload={remote.reload} />)}</div>;
};

export default function Orders() {
  const { user } = useAuth();
  const remote = useRemote('/orders');
  return <>
    <PageTitle eyebrow="KEEP BUSINESS MOVING" title="Purchase orders.">From accepted quotation to final delivery.</PageTitle>
    <OrderList remote={remote} user={user} />
  </>;
}